import axios, { AxiosError } from 'axios';
import { DELETE_ATTACHED_FILES_API_URL, FILES_DELETE_URL } from '../../const/const';
import { File } from '../../types/File';

interface DeleteAttachedFileData {
    UID: string;
}
export const DeleteAttachedFile = async (
    SmartDVRToken: string,
    userLogin: string,
    file: DeleteAttachedFileData,
) => {
    if (!userLogin || !SmartDVRToken) {
        console.error('User information is missing.');
        return;
    }

    try {
        const response = await axios.post(
            DELETE_ATTACHED_FILES_API_URL,
            { UID: file.UID },
            {
                headers: {
                    SmartDVRLogin: userLogin,
                    SmartDVRToken: SmartDVRToken,
                },
            },
        );

        if (response.data?.error) {
            throw new Error(response.data.error);
        }

        return response.data;
    } catch (error) {
        const err = error as AxiosError;
        let errorMessage = 'Ошибка при удалении файла';

        if (err.response) {
            errorMessage = err.response.status === 404 ? 'Файл не найден' : errorMessage;
        }

        throw new Error(errorMessage);
    }
};
